export default {
  error: {
    backgroundColor: 'red',
    color: '#ffffff',
    marginBottom: 20,
    minWidth: 0,
    marginLeft: 20,
    marginRight: 20
  }
};